import axiosClient from "api/axios_client.js";

const BASE = "/knowledge-management/knowledge-configuration/knowledge-hub";

const apiKnowledgeHub = {
  getAll: (payload) => axiosClient.post(`${BASE}/get-all`, payload),
  getArticle: (id) => axiosClient.get(`${BASE}/article/${id}`),
  recordView: (id, duration) => axiosClient.post(`${BASE}/article/${id}/view`, { duration }),
  toggleBookmark: (id) => axiosClient.post(`${BASE}/article/${id}/bookmark`),
  togglePin: (id) => axiosClient.post(`${BASE}/article/${id}/pin`),
  toggleLike: (contentId) => axiosClient.post(`${BASE}/content/${contentId}/like`),
  addComment: (contentId, payload) => axiosClient.post(`${BASE}/content/${contentId}/comment`, payload),
  deleteComment: (commentId) => axiosClient.delete(`${BASE}/comment/${commentId}`),
  pinComment: (commentId) => axiosClient.post(`${BASE}/comment/${commentId}/pin`),
};

export default apiKnowledgeHub;
